import axios from "axios";
import http from "./http-common";
import { url } from "../../../../configlink";


const upload = (file, orderId, userId, mode, onUploadProgress) => {
  let formData = new FormData();

  console.log("funcion was called+==" + userId, orderId, mode);

  formData.append("file", file);
  
  return axios.post(
    `${url}/api/file/upload?mode=` + mode + "&orderId=" + orderId + "&userId=" + userId,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    }
  );
};

// const getFiles = () => {
//   return http.get("/files");
//   return null;
// };

const UploadService = {
  upload,
  // getFiles,
};

export default UploadService;
